import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "onCloseClick", "$styles"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, IconButton } from '@miro-site/core';
import React from 'react';
import styled, { useTheme } from 'styled-components';
import { Close } from '../icons/Icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Popup = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      onCloseClick = _ref.onCloseClick,
      $styles = _ref.$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();
  return /*#__PURE__*/_jsxs(PopupWrapper, _objectSpread(_objectSpread({
    ref: ref,
    $p: 20,
    $pt: 70,
    $styles: _objectSpread({
      position: 'relative',
      borderRadius: [0, 16, 16, 16],
      background: 'primaryWhite'
    }, $styles)
  }, props), {}, {
    children: [/*#__PURE__*/_jsx(IconButton, {
      label: "Close popup",
      onClick: function onClick(e) {
        e.preventDefault();

        if (onCloseClick) {
          onCloseClick(e);
        }
      },
      icon: /*#__PURE__*/_jsx(Close, {}),
      $styles: {
        position: 'absolute',
        top: 20,
        right: 20,
        borderRadius: '50%',
        width: 36,
        height: 36,
        ':hover': {
          background: theme.templates.colors.secondary4
        }
      }
    }), children]
  }));
});
Popup.displayName = 'Popup';
var PopupWrapper = styled(Box).withConfig({
  displayName: "Popup__PopupWrapper",
  componentId: "sc-15wwhzm-0"
})(["box-shadow:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.templates.elevation.overlay;
});
export default Popup;